// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"UpdateFirmwareModal_subtitle__2eJ7m","textButton":"UpdateFirmwareModal_textButton__2jqUg"};